import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
// import Link from "./LinkWithTransitionLock";
// import svgPanZoom from "svg-pan-zoom";
// import Hammer from "hammerjs";
// import { isMobile } from "mobile-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";

import data from "../data/art";

import ScrollTrigger from "gsap/ScrollTrigger";
import { forEach } from "lodash";

import Map from "../components/LoadableMap";
// import Map from "./Map";
import main_map_mobile from "../images/2021_map_mobile.jpg";
import main_map_desktop from "../images/2021_map_desktop.jpg";

import ArtistModal from "./artists_modal.js";
import window from "global";

import WebGL from "./../js/artists/app.js";

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeArtistIndex: null,
    };
  }

  // static contextType = VideoIsPlayedContext;

  componentDidMount() {
    new WebGL();

    gsap.registerPlugin(ScrollTrigger);
    var window_width = window.innerWidth;
    var window_height = window.innerHeight;
    var window_height_mobile = window.outerHeight;

    var body = document.body;
    // var artwork_inner_close_btn = document.querySelector(
    //   ".artwork_inner_close_btn"
    // );
    var map_trigger = document.querySelector(".map_trigger");
    map_trigger.addEventListener("click", function() {
      body.classList.add("map_active");
    });

    var artist_item = document.querySelectorAll(".artist_item");
    artist_item.forEach((item) => {
      var thumbanil = item.dataset.thumbanil;
      item.addEventListener("mouseover", function(event) {
        const x = event.clientX;
        const y = event.clientY;

        // document.querySelector(
        //   ".artwork_cover .thumbanil"
        // ).style.backgroundImage = "url(" + thumbanil + ")";
        // var tl_1 = new TimelineMax();
        gsap.to(".artwork_cover", {
          top: y,
          left: x,
          // rotate: -rotate,
          opacity: 1,
          duration: 0.3,
          ease: Power3.easeOut,
        });
      });
      item.addEventListener("mouseleave", function(event) {
        // var tl_2 = new TimelineMax();
        gsap.to(".artwork_cover", {
          opacity: 0,
          duration: 0.3,
          ease: Power3.easeOut,
        });
      });
      // item.addEventListener("click", function(event) {
      //   // var item_id = item.dataset.artwork;
      //   body.classList.add("artwork_inner_active");
      // });
    });

    // artwork_inner_close_btn.addEventListener("click", () => {
    //   body.classList.remove("artwork_inner_active");
    // });
  }

  componentWillUnmount() {}

  setActiveArtistIndex = (nweIndex) => {
    // nweIndex === null
    //   ? document.body.classList.remove("artwork_inner_active")
    //   : document.body.classList.add("artwork_inner_active");
    // this.setState({ activeArtistIndex: nweIndex });

    // const duration = 0.3;
    if (nweIndex === null) {
      // console.log('haha')
      document.body.classList.remove("artwork_inner_active");
      // gsap.to(".artwork_inner_wrapper", {
      //   opacity: 0,
      //   duration: 1,
      //   pointerEvents: "none",
      //   ease: Power2.easeOut,
      // });
      gsap.to(".artwork_inner_cover", {
        opacity: 0,
        duration: 1,
        pointerEvents: "none",
        ease: Power2.easeOut,
        onComplete: () => {
          this.setState({ activeArtistIndex: nweIndex });
        },
      });
      // gsap.to(".artwork_inner_close_btn", {
      //   opacity: 0,
      //   duration: 0.3,
      //   pointerEvents: 'none',
      //   ease: Power2.easeOut,
      // });
      // setTimeout(() => this.setState({ activeArtistIndex: nweIndex }), duration*2000);
    } else {
      document.body.classList.add("artwork_inner_active");
      // gsap.to(".artwork_inner_wrapper", {
      //   opacity: 1,
      //   duration: 1,
      //   pointerEvents: "all",
      //   ease: Power2.easeOut,
      //   // onComplete: () => {
      //   //   this.setState({ activeArtistIndex: nweIndex })
      //   // }
      // });
      gsap.to(".artwork_inner_cover", {
        opacity: 1,
        duration: 1,
        pointerEvents: "all",
        ease: Power2.easeOut,
      });
      this.setState({ activeArtistIndex: nweIndex });
      // gsap.to(".artwork_inner_close_btn", {
      //   opacity: 1,
      //   duration: 0.3,
      //   pointerEvents: 'all',
      //   ease: Power2.easeOut,
      // });
      // this.setState({ activeArtistIndex: nweIndex });
    }
  };

  render() {
    return (
      <>
        <section className="main_map section_container">
          <div className="inner_content">
            <h3 className="section_main_title">
              導覽地圖<div className="en">Guide Map</div>
            </h3>
            <div className="photo map_thumbnail map_trigger">
              <img src={main_map_desktop} className="desktop" alt="導覽地圖" />
              <img src={main_map_mobile} className="mobile" alt="導覽地圖" />
              <div className="note_text_label">體驗作品導覽地圖</div>
            </div>
          </div>
        </section>
        <section className="artists section_container" id="main">
          <div className="inner_content">
            <h3 className="section_main_title">
              作品與藝術家<div className="en">Artworks & Artists</div>
            </h3>
            <div className="artists_grid grid_area_3_ms">
              {data.map((art, index) => (
                <div
                  className="artist_item"
                  data-thumbanil={art.img[0]}
                  data-artwork={"art" + index}
                  onClick={() => this.setActiveArtistIndex(index)}
                >
                  <h4 className="art_title">
                    <div className="zh">{art.title_zh}</div>
                    <div className="en">{art.title_en}</div>
                  </h4>
                  <p className="tag_list">
                    {art.tag_zh} <br />
                    {art.tag_en}
                  </p>
                  <h5 className="art_author">
                    <div className="author">
                      {art.author_zh} <br />
                      {art.author_en}
                    </div>
                  </h5>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="artwork_cover">
          <div className="thumbanil ratio_1_1"></div>
        </div>

        <Map setActiveArtistIndex={this.setActiveArtistIndex} />

        <ArtistModal
          activeArtistIndex={this.state.activeArtistIndex}
          setActiveArtistIndex={this.setActiveArtistIndex}
        />

        <Helmet
          title="作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival"
          meta={[
            {
              name: `description`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:title`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:description`,
              content:
                "作品與藝術家・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: require("../images/og_image.jpg"),
            },
          ]}
        ></Helmet>
      </>
    );
  }
}

export default Page;
